import { useCallback } from 'react';

import { useRouter } from 'next/router';

import { useNiceModal } from '~/src/common/services/ModalsManager';

const useOpenCartModal = () => {
  const { replace, pathname } = useRouter();

  const { show: openCartModal } = useNiceModal('cart-modal');

  const openCart = useCallback(async () => {
    await replace(pathname, undefined, { shallow: true, scroll: false });

    void openCartModal();
  }, [pathname, openCartModal, replace]);

  return openCart;
};

export default useOpenCartModal;
